import React from "react";
import { Button } from "@material-ui/core";
import shortfetch from "../../../components/data/fetch";

const CopyModelData = (props) => {
  const { history, Change_State, ModelID, max } = props;

  const copy_model_data = async () => {
    let post_json = {
      type: "copy_model_data_DINH",
      currentID: ModelID,
      auth: localStorage.getItem("auth"),
    };

    let data = await shortfetch(post_json);

    if (data.geslaagd) {
      let newID = Number(max) + 1;
      history.push("/Form/Modellen/Die/Ik/Niet/Heb/" + newID);
      Change_State(newID);
    } else {
      alert("Er is iets fout gegaan tijdens het opslaan.");
    }
  };

  return (
    <Button onClick={() => copy_model_data()} style={{ background: "white" }}>
      Model {ModelID} kopiëren
    </Button>
  );
};

export default CopyModelData;
